export default [
  { id: 1, title: "Contract Prototype", name: "E1@2x.png", screenshots: [] },
  {
    id: 2,
    title: "TSX Conference Micro-Site",
    name: "STX_MICROSITE@2x.png",
    screenshots: [],
  },
  {
    id: 3,
    title: "Air Shopping Demo",
    name: "daily best fares @2x.png",
    screenshots: [],
  },
  {
    id: 4,
    title: "Hospital Group Portal",
    name: "hospital_group_portal.png",
    screenshots: [],
  },
  {
    id: 5,
    title: "Air Shopping Dashboard",
    name: "227467350.png",
    screenshots: [],
  },
  { id: 6, title: "APRICOT Demo", name: "02-search@2x.png", screenshots: [] },
  {
    id: 7,
    title: "Flight Booking Demo",
    name: "ASE Search@2x.png",
    screenshots: [],
  },
  {
    id: 8,
    title: "RFP Process Wireframes",
    name: "_Consortia RFP Home - Hotel List Reviewed.png",
    screenshots: ["0.png", "1.png", "2.png", "3.png", "4.png", "5.png"],
  },
  {
    id: 9,
    title: "Corporate Performance Dashboards",
    name: "Air 2@2x.png",
    screenshots: [],
  },
  {
    id: 10,
    title: "Guest Experience Manager",
    name: "_Volumes_BRIGGS_gem-demo_index.png",
    screenshots: [],
  },
  {
    id: 11,
    title: "Hackday 2014",
    name: "_Volumes_BRIGGS_hackday_index.png",
    screenshots: [],
  },
  {
    id: 12,
    title: "Hospitality Workshop",
    name: "4. Destinations -add.png",
    screenshots: [],
  },
];
